module.exports = __webpack_public_path__ + "static/media/5.93415750.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/5.jpg
// module id = 423
// module chunks = 0